// react
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
// me
import { IRootViewModel } from "../models/models";
import LicenceSummaryView from "./LicenceSummaryView";
import LicenceHolderView from "./LicenceHolderView";
import MemorialView from "./MemorialView";

export enum LicenceDetailsTabsEnum {
    Summary,
    LicenceHolder,
    Memorial,
}

interface IProps {
    vm: IRootViewModel;
    preferredTab: LicenceDetailsTabsEnum;
}

export default function DetailsView(props: IProps) {
    const { vm, preferredTab } = props;

    return (
        <Tabs defaultActiveKey={preferredTab.toString()} variant="pills" mountOnEnter>
            {/* Summary Tab */}
            <Tab eventKey={LicenceDetailsTabsEnum.Summary.toString()} title="Licence Summary">
                <LicenceSummaryView summary={vm.summary} />
            </Tab>

            {/* Licence Holders Tab */}
            <Tab eventKey={LicenceDetailsTabsEnum.LicenceHolder.toString()} title="Licence Holder">
                <LicenceHolderView licenceHolder={vm.licenceHolder} />
            </Tab>

            {/* Memorial Tab */}
            <Tab eventKey={LicenceDetailsTabsEnum.Memorial.toString()} title="Register">
                <MemorialView licenceNumber={vm.summary?.licenceNumber} memorial={vm.memorial} />
            </Tab>
        </Tabs>
    );
}
